import {
    Button, Container, IconButton, InputAdornment, Paper,
    TextField, Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ServiceAPI from '../../services/serviceapi';
import tokenService from '../../services/tokenservice';
import { SecUtils } from '../../utils/secutils';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router';
import { RESPONSE } from '../../enums/response';

const Login = React.forwardRef((props, ref) => {
    const [searchParams] = useSearchParams();
    const [empresaID, setEmpresaID] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [senha, setSenha] = useState<string>('');
    const [erro, setErro] = useState<string>('');
    const [mostrarSenha, setMostrarSenha] = useState<boolean>(false);

    const navigate = useNavigate();

    useEffect(() => {
        const xsParam = searchParams.get('xs');
        if (xsParam) setEmpresaID(xsParam);
    }, [searchParams]);

    const podeLogar = () => {
        const isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        const empresaIDValid = empresaID?.length >= 3;
        const senhaValid = senha?.length > 3;
        return isEmail && empresaIDValid && senhaValid;
    }

    const logar = async () => {
        const data = {
            "e": SecUtils.encode(email),
            "p": SecUtils.encode(senha)
        };

        ServiceAPI.logar(empresaID, data).then(async (response) => {
            if (RESPONSE.SUCESSO_LOGIN === response.codeResponse) {
                let tkn = response.dataResponse;
                tkn.empresaID = empresaID;

                await tokenService.saveToken(tkn);
                navigate("/gestao");
            }
        }).catch((error) => {
            if (error.response?.data) {
                setErro(error.response?.data.message);
            } else {
                setErro(error.message);
            }
        });
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && podeLogar()) {
            logar();
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 10 }}>
            <Paper elevation={3} sx={{ padding: 4, textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    Login - Gestão AppCodesh
                </Typography>

                <TextField
                    fullWidth
                    label="Empresa"
                    variant="outlined"
                    value={empresaID}
                    onChange={(e) =>{setEmpresaID((e.target.value.replaceAll(' ', '')?? '').toLocaleLowerCase())}}
                    sx={{ my: 3 }}
                />

                <TextField
                    fullWidth
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    sx={{ my: 3 }}
                />

                <TextField
                    fullWidth
                    label="Senha"
                    type={mostrarSenha ? 'text' : 'password'}
                    variant="outlined"
                    value={senha}
                    onChange={e => setSenha(e.target.value)}
                    onKeyDown={handleKeyDown}
                    error={!!erro}
                    helperText={erro}
                    sx={{ my: 3 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setMostrarSenha(!mostrarSenha)}
                                    edge="end"
                                    aria-label="toggle password visibility"
                                >
                                    {mostrarSenha ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />

                <Button
                    variant="contained"
                    sx={{ bgcolor: "black" }}
                    fullWidth
                    size="large"
                    onClick={logar}
                    disabled={!podeLogar()}
                >
                    Entrar
                </Button>
            </Paper>
        </Container>
    );
});

export default Login;
